module.exports = __webpack_public_path__ + "static/img/web_home_6.163501b.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/extensionPage/web_home_6.png
// module id = xyWW
// module chunks = 0